import {
  isClassificationReasonExtractedFile,
  isClassificationReasonGoodwareOverride
} from "../ClassificationSource";
import styles from "./classification-reason.module.scss";

type Props = {
  source?: number;
  style?: string;
};

const getIcon = (style: string, source?: number) => {
  if (!source) return style;

  if (isClassificationReasonExtractedFile(source)) {
    return "extracted-files";
  }
  if (isClassificationReasonGoodwareOverride(source)) {
    return "goodware-override";
  }
  return style;
};

const ClassificationReasonIcon = ({ source, style }: Props) => {
  if (!style) return null;
  const icon = getIcon(style, source);
  return (
    <>
      {style && (
        <span
          data-testid="classification-reason-icon"
          className={`reason__icon--${icon} ${
            styles.classification_reason_icon
          } ${
            styles[`classification_reason_icon_${icon}`]
          } k-pdf-icon-right-margin`}
        />
      )}
    </>
  );
};

export default ClassificationReasonIcon;
